module.exports = __webpack_public_path__ + "media/icons/running-c3e1009c.svg";